import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'sanitaizer',
})
export class SanitaizerPipe implements PipeTransform {
  constructor(private sanitaizer: DomSanitizer) {}

  transform(value: any, args?: any): any {
    return this.sanitaizer.bypassSecurityTrustResourceUrl(value);
  }
}
